import { Page } from '@dixa/lib-shared-habla';
import { useMount } from 'react-use';

import { useCopilotTrial } from 'utils/useCopilotTrial';

import { SettingsCopilotTrialFeaturesLearnMore } from './components/featuresLearnMore/settingsCopilotTrialFeaturesLearnMore';
import { SettingsCopilotTrialCallToAction } from './components/settingsCopilotTrialCallToAction';
import { SettingsCopilotTrialTestimony } from './components/settingsCopilotTrialTestimony';

export const SettingsCopilotTrialView = (): JSX.Element => {
  const { visitedTrialPage, setVisitedTrialPage } = useCopilotTrial();

  useMount(() => {
    if (!visitedTrialPage) {
      setVisitedTrialPage();
    }
  });

  return (
    <Page>
      <Page.Head title="New: Agent Co-pilot" />
      <Page.Body>
        <Page.Section>
          <SettingsCopilotTrialCallToAction />
        </Page.Section>
        <Page.Section title="What is Agent Co-pilot?">
          <SettingsCopilotTrialFeaturesLearnMore />
        </Page.Section>
        <Page.Section title="What other companies are saying about it?">
          <SettingsCopilotTrialTestimony />
        </Page.Section>
      </Page.Body>
    </Page>
  );
};
